// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OPx1X","col":"styles_col__DfADS"};